import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BuyingPowerDetails, CombinedOrderRequest, MultiExanteResponse, OrderData, OrderRequest, Quote } from '@zero/shared/util-models';
import { MultiOrderInstrument } from '../entities/multi-order-instrument';
import { MultiOrderNotice } from '../entities/multi-order-notice';
import { MultiOrderValidationErrorResponse } from '../entities/multi-order-validation-error';
import { TradingDayInfo } from '../entities/trading-day-info.entity';
import { UserExperienceData } from '../entities/user-experience-data.entity';

export const tradeActions = createActionGroup({
  source: 'Trade',
  events: {
    'Load holidays': emptyProps(),
    'Load trading day info': props<{ isin: string }>(),
    'Load Multi Order Consent': emptyProps(),
    'Confirm Multi Order Consent': emptyProps(),
    'Add Multi Order Instruments': props<{ instruments: MultiOrderInstrument[] }>(),
    'Add Multi Order Instrument': props<{ instrument: MultiOrderInstrument }>(),
    'Remove Multi Order Instrument': props<{ instrument: MultiOrderInstrument }>(),
    'Clear Multi Order': emptyProps(),
    'Remove Multi Order Instruments': emptyProps(),
    'Subscribe to Push Quote': props<{ instrument: MultiOrderInstrument }>(),
    'Set Multi Order Instrument Error': props<{ instrument: MultiOrderInstrument; error: string }>(),
    'Update Quote': props<{ isin: string; quote: Quote }>(),
    'Update Quotes': props<{ quotes: Record<string, Quote> }>(),
    'Update Quantity': props<{ instrument: MultiOrderInstrument; quantity: number }>(),
    'Load Buying Power': emptyProps(),
    'Validate Multi Order': emptyProps(),
    'Reset Multi Order Verification': emptyProps(),
    'Send Multi Order': emptyProps(),
    'Set Minimum Quantity Surcharge': props<{ instrument: MultiOrderInstrument; value: number }>(),
    'Set Multi Order Instrument Notice': props<{ instrument: MultiOrderInstrument; notice: MultiOrderNotice }>(),
    'Confirm Multi Order Instrument Notice': props<{ instrument: MultiOrderInstrument }>(),
    'Load Exante': emptyProps(),
    'Verify Order': props<{ orderData: OrderRequest }>(),
    'Validate Combined Order': props<{ combinedOrder: CombinedOrderRequest }>(),
    'Remove Fractional Order': emptyProps(),
    'Place Order': props<{ orderRequest: OrderRequest }>(),
    'Place Combined Order': props<{ combinedOrderRequest: CombinedOrderRequest }>(),
    'Load Knowledge And Experience Form': props<{ isins: string[] }>(),
    'Submit Knowledge And Experience Form': props<{ userExperienceData: UserExperienceData }>(),
    Reset: emptyProps(),
  },
});

export const tradeApiActions = createActionGroup({
  source: 'Trade API',
  events: {
    'Load holidays from api': emptyProps(),
    'Load holidays success': props<{ holidays: string[] }>(),
    'Load holidays failure': props<{ error: HttpErrorResponse }>(),
    'Load trading day info success': props<{ tradingDayInfo: TradingDayInfo }>(),
    'Load trading day info failure': props<{ error: HttpErrorResponse }>(),
    'Load Multi Order Consent success': props<{ shouldDisplayConsent: boolean }>(),
    'Load Multi Order Consent failure': props<{ error: HttpErrorResponse }>(),
    'Add Multi Order Instruments success': props<{ instruments: MultiOrderInstrument[] }>(),
    'Add Multi Order Instruments failure': props<{ error: HttpErrorResponse }>(),
    'Confirm Multi Order Consent success': emptyProps(),
    'Confirm Multi Order Consent failure': props<{ error: HttpErrorResponse }>(),
    'Load Buying Power success': props<{ buyingPower: BuyingPowerDetails }>(),
    'Load Buying Power failure': props<{ error: HttpErrorResponse }>(),
    'Validate Multi Order success': emptyProps(),
    'Validate Multi Order failure': props<{ error: MultiOrderValidationErrorResponse }>(),
    'Send Multi Order success': emptyProps(),
    'Send Multi Order failure': props<{ error: MultiOrderValidationErrorResponse }>(),
    'Load Exante success': props<{ multiExante: MultiExanteResponse }>(),
    'Load Exante failure': props<{ error: HttpErrorResponse }>(),
    'Verify Order Success': emptyProps(),
    'Verify Order Failure': props<{ error: HttpErrorResponse }>(),
    'Validate Combined Order Success': props<{ orders: OrderData[] }>(),
    'Validate Combined Order Failure': props<{ error: HttpErrorResponse }>(),
    'Place Order Success': emptyProps(),
    'Place Order Failure': props<{ error: HttpErrorResponse }>(),
    'Place Combined Order Success': emptyProps(),
    'Place Combined Order Failure': props<{ error: HttpErrorResponse }>(),
    'Load Knowledge And Experience Form Success': props<{ response: UserExperienceData }>(),
    'Load Knowledge And Experience Form Failure': props<{ error: HttpErrorResponse }>(),
    'Submit Knowledge And Experience Form Success': emptyProps(),
    'Submit Knowledge And Experience Form Failure': props<{ error: HttpErrorResponse }>(),
  },
});
